__turbopack_context__.v({
  "clickableIcon": "PageNavigation-module-scss-module__kKwbZq__clickableIcon",
  "notClickable": "PageNavigation-module-scss-module__kKwbZq__notClickable",
  "notClickableIcon": "PageNavigation-module-scss-module__kKwbZq__notClickableIcon",
  "pagers": "PageNavigation-module-scss-module__kKwbZq__pagers",
});
